/**
 * FAQ vocales conversationnelles — ciblent les requêtes « Ok Google… »,
 * « réparateur près de moi », etc. Fusionnées au JSON-LD FAQPage + speakable.
 */
import { PHONE_DISPLAY } from "../components/Layout";

export function getCityVoiceFaq(city) {
    return [
        {
            q: `Qui propose la réparation électroménager à ${city.name} près de chez moi ?`,
            a: `Electrocase assure la réparation d'électroménager à domicile à ${city.name} (${city.postal}) : lave-linge, lave-vaisselle, frigo, four et sèche-linge, toutes marques. Un technicien intervient sous 24 à 48 heures. Appelez le ${PHONE_DISPLAY}.`,
        },
        {
            q: `Combien coûte un réparateur d'électroménager à ${city.name} ?`,
            a: `Le devis est gratuit par téléphone et le tarif est annoncé avant l'intervention, sans frais caché. Le Bonus Réparation de l'État peut réduire la facture jusqu'à 60 euros.`,
        },
        {
            q: `Peut-on faire réparer son électroménager le jour même à ${city.name} ?`,
            a: `Oui selon le planning : les urgences (frigo en panne, fuite de lave-linge) sont traitées en priorité à ${city.name} et alentours, souvent le jour même. Intervention standard sous 24-48 h, garantie 18 mois.`,
        },
    ];
}

export function getServiceVoiceFaq(s) {
    const nom = s.nav.toLowerCase();
    return [
        {
            q: `Qui répare un ${nom} près de chez moi ?`,
            a: `Electrocase répare les ${nom} à domicile dans tout Paris et l'Île-de-France (92, 78, 94). Un technicien proche de chez vous intervient sous 24 à 48 heures. Appelez le ${PHONE_DISPLAY} pour un devis gratuit.`,
        },
        {
            q: `Combien coûte la réparation d'un ${nom} à Paris ?`,
            a: `Le devis est gratuit par téléphone et le tarif final est annoncé avant toute intervention, sans frais caché. Le Bonus Réparation de l'État peut réduire la facture jusqu'à 60 euros.`,
        },
        {
            q: `Peut-on réparer un ${nom} le jour même ?`,
            a: `Oui, selon le planning : les urgences sont traitées en priorité à Paris et en proche couronne, souvent le jour même ou le lendemain. Intervention standard sous 24 à 48 heures.`,
        },
        {
            q: `Faut-il réparer ou remplacer un ${nom} en panne ?`,
            a: `Si l'appareil a moins de 10 ans, la réparation est presque toujours plus rentable : elle coûte en moyenne 4 fois moins cher qu'un remplacement et toutes nos réparations sont garanties 18 mois.`,
        },
    ];
}
